import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";

import './ToolTip.css';
import tooltip from "../../../resources/images/tooltip.png";
import {createToolTip, retrieveToolTip, updateToolTip} from "../../../services/ToolTipService";
import {StandardButton} from "../button/standard-button/StandardButton";

export const ToolTip = ({
                            context,
                            fieldName,
                            tooltipExternalReference,
                            showToaster,
                            setSpinnerText
                        }) => {

    ReactModal.setAppElement('#root');

    const [retrievedToolTip, setRetrievedToolTip] = useState(null);
    const [message, setMessage] = useState("Create new tool tip message..");
    const [retrievedMessage, setRetrievedMessage] = useState("Create new tool tip message..");
    const [show, setShow] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const handleShow = async () => {
        setShow(true);
        await fetchToolTip();
    }
    const handleUpdate = () => setShowUpdate(!showUpdate);
    const handleClose = () => {
        setShow(false);
        setShowUpdate(false);
    }

    const handleSubmitClick = async () => {
        const toolTipToBeSaved = {
            externalReference: tooltipExternalReference,
            tooltip: message,
            systemUserName: context.username,
            contextExternalReference: null,
            contextName: "Problem",
        };
        if (retrievedToolTip === null) {
            setSpinnerText("Creating ToolTip");
            const response = await createToolTip(context.username, toolTipToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating ToolTip");
            const response = await updateToolTip(context.username, toolTipToBeSaved);
            handleResponse(response);
        }
        setShow(!show);
        setShowUpdate(false);
        setRetrievedMessage(message);
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setSpinnerText(null);
    }

    const fetchToolTip = async () => {
        const [data] = await retrieveToolTip(context.username, tooltipExternalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                const toolTip = data.tooltipVOToView;
                if (toolTip) {
                    setRetrievedToolTip(toolTip);
                    setRetrievedMessage(toolTip.tooltip);
                    setMessage(toolTip.tooltip);
                }
                setSpinnerText(null);
            }
        }
    }

    const handleMessageChange = (event) => {
        setMessage(event.target.value);
    }

    const roles = context.roles;
    let isAdmin;
    if (null !== roles) {
        isAdmin = roles.includes("QIT_ADMIN");
    }

    return (
        <div className="tooltip-container">
            <div>
                <button className="info-icon-button" onClick={handleShow}>
                    <img src={tooltip} alt={"tooltip-icon"} className={"fa-icon-t"}/>
                </button>
            </div>

            <ReactModal isOpen={show} className="modal-content-t" overlayClassName="modal-overlay">
                <p className={"modal-header-t"}>{fieldName}</p>
                <div className={"modal-info-group"}>
                    {showUpdate && <textarea className={"text-input-t"} onChange={handleMessageChange}
                                             spellCheck="true" value={message}/>}
                    {!showUpdate && <textarea className={"text-box-t"} value={retrievedMessage} readOnly={true}>
                    </textarea>}
                </div>
                <div className={"modal-button-group"}>
                    <div className={"modal-button-group-mid"}>
                        {showUpdate && <StandardButton onClick={handleUpdate} text={"Back"}/>}
                        {!showUpdate && <StandardButton onClick={handleClose} text={"  Ok  "}/>}
                        {(isAdmin && showUpdate) && <StandardButton onClick={handleSubmitClick} text={"Save"}/>}
                        {(isAdmin && !showUpdate) && <StandardButton onClick={handleUpdate} text={"Update"}/>}
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}